export default "__VITE_ASSET__DlAKbZJz__"